// extracted by mini-css-extract-plugin
module.exports = {"calldata":"style_calldata__SlwwJ"};